import {practiceStateActions} from '../../const/actionType';

export const setPractices = (departmentId, practices) => ({
  type: practiceStateActions.SET_PRACTICES,
  departmentId,
  practices: practices,
});

export const setSelectedPractice = (selected) => ({
  type: practiceStateActions.SET_SELECTED_PRACTICE,
  selected,
});

export const resetPractices = () => ({
  type: practiceStateActions.RESET_PRACTICE,
});
